import React, { useState } from 'react';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('Sending...');

        // Use REACT_APP_ prefix for Create React App projects
        const BREVO_API_KEY = process.env.REACT_APP_BREVO_API_KEY;
        const isLocalDev = window.location.hostname === 'localhost';

        // Shared template for local fallback
        const getEmailTemplate = (data) => `
            <div style="background:#f4f6f8;padding:40px 0;font-family:Arial,Helvetica,sans-serif;color:#333;">
                <table align="center" width="600" cellpadding="0" cellspacing="0" style="background:#ffffff;border-radius:10px;overflow:hidden;box-shadow:0 4px 15px rgba(0,0,0,0.08);">
                    <tr>
                        <td style="background:#111827;padding:30px;text-align:center;">
                            <h1 style="color:#ffffff;margin:0;font-size:22px;">New Contact Message</h1>
                            <p style="color:#9ca3af;font-size:13px;margin-top:5px;">Portfolio Website Inquiry</p>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding:40px 30px;">
                            <h2 style="margin-top:0;color:#111827;font-size:20px;">Hello Sahil 👋</h2>
                            <p style="color:#555;font-size:15px;line-height:1.6;margin-bottom:25px;">
                                You received a new message from your portfolio contact form.
                            </p>
                            <table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #eee;border-radius:8px;overflow:hidden;margin-bottom:30px;">
                                <tr>
                                    <td style="padding:15px;background:#fafafa;border-bottom:1px solid #eee;font-size:14px;width:30%;"><strong>Name:</strong></td>
                                    <td style="padding:15px;background:#fafafa;border-bottom:1px solid #eee;font-size:14px;">${data.name}</td>
                                </tr>
                                <tr>
                                    <td style="padding:15px;border-bottom:1px solid #eee;font-size:14px;"><strong>Email:</strong></td>
                                    <td style="padding:15px;border-bottom:1px solid #eee;font-size:14px;">${data.email}</td>
                                </tr>
                                <tr>
                                    <td style="padding:15px;font-size:14px;"><strong>Subject:</strong></td>
                                    <td style="padding:15px;font-size:14px;">${data.subject}</td>
                                </tr>
                            </table>
                            <div style="margin-top:25px;">
                                <h3 style="margin-bottom:12px;color:#111827;font-size:16px;">Message</h3>
                                <div style="background:#f9fafb;border-left:4px solid #2563eb;padding:20px;border-radius:6px;color:#444;font-size:14px;line-height:1.8;white-space:pre-wrap;">${data.message}</div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        `;

        try {
            // Attempt to call the secure Cloudflare Function first
            let response = await fetch('/api/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            // If we get a 404 and we're on localhost, it's likely the React dev server.
            // In this case, we try the direct Brevo API call if we have a key.
            if (response.status === 404 && isLocalDev && BREVO_API_KEY) {
                console.log("Local development detected, falling back to direct Brevo API call...");
                response = await fetch('https://api.brevo.com/v3/smtp/email', {
                    method: 'POST',
                    headers: {
                        'accept': 'application/json',
                        'api-key': BREVO_API_KEY,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        sender: { name: "Portfolio Contact (Local Dev)", email: "sahil021mohammad@gmail.com" },
                        replyTo: { name: formData.name, email: formData.email },
                        to: [{ email: "sahil021mohammad@gmail.com", name: "Mohammad Sahil" }],
                        subject: `[LOCAL DEV] ${formData.subject}`,
                        htmlContent: getEmailTemplate(formData)
                    })
                });
            }

            const contentType = response.headers.get("content-type");
            if (response.ok && contentType && contentType.indexOf("application/json") !== -1) {
                setStatus('Message sent successfully!');
                setFormData({ name: '', email: '', subject: '', message: '' });
            } else if (response.status === 404) {
                setStatus('API Endpoint not found. If local, use Wrangler or add your API key to .env as REACT_APP_BREVO_API_KEY.');
            } else {
                const errorText = await response.text();
                console.error('API Error:', errorText);
                setStatus('Failed to send message. Please check the console for details.');
            }
        } catch (error) {
            console.error('Fetch Error:', error);
            setStatus('An error occurred. Make sure your internet is working or check the console.');
        }
    };

    return (
        <section className="ftco-section contact-section ftco-no-pb" id="contact-section">
            <div className="container">
                <div className="row justify-content-center mb-5 pb-3">
                    <div className="col-md-7 heading-section text-center" data-aos="fade-up">
                        <h1 className="big big-2">Contact</h1>
                        <h2 className="mb-4">Contact Me</h2>
                        <p>
                            Interested in building scalable, high-performance digital solutions? I’m available for professional engagements, enterprise projects, and long-term collaborations.
                        </p>
                    </div>
                </div>

                <div className="row d-flex contact-info mb-5">
                    <div className="col-md-6 col-lg-4 d-flex" data-aos="fade-up">
                        <div className="align-self-stretch box p-4 text-center">
                            <div className="icon d-flex align-items-center justify-content-center">
                                <span className="icon-map-signs"></span>
                            </div>
                            <h3 className="mb-4">Address</h3>
                            <p>Sector 21-B, Chandigarh</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 d-flex" data-aos="fade-up" data-aos-delay="100">
                        <div className="align-self-stretch box p-4 text-center">
                            <div className="icon d-flex align-items-center justify-content-center">
                                <span className="icon-phone2"></span>
                            </div>
                            <h3 className="mb-4">Contact Number</h3>
                            <p><a href="tel://+919592407801">+91 95924 07801</a></p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 d-flex" data-aos="fade-up" data-aos-delay="200">
                        <div className="align-self-stretch box p-4 text-center">
                            <div className="icon d-flex align-items-center justify-content-center">
                                <span className="icon-paper-plane"></span>
                            </div>
                            <h3 className="mb-4">Email Address</h3>
                            <p><a href="mailto:sahil021mohammad@gmail.com">sahil021mohammad@gmail.com</a></p>
                        </div>
                    </div>

                </div>

                <div className="row no-gutters block-9">
                    <div className="col-md-6 order-md-last d-flex">
                        <form onSubmit={handleSubmit} className="bg-light p-4 p-md-5 contact-form">
                            <div className="form-group">
                                <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Your Name" required />
                            </div>
                            <div className="form-group">
                                <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" placeholder="Your Email" required />
                            </div>
                            <div className="form-group">
                                <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="form-control" placeholder="Subject" required />
                            </div>
                            <div className="form-group">
                                <textarea name="message" value={formData.message} onChange={handleChange} cols="30" rows="7" className="form-control" placeholder="Message" required></textarea>
                            </div>
                            <div className="form-group">
                                <input type="submit" value={status === 'Sending...' ? 'Sending...' : 'Send Message'} disabled={status === 'Sending...'} className="btn btn-primary py-3 px-5" />
                            </div>
                            {status && status !== 'Sending...' && (
                                <div className={`mt-3 ${status.includes('success') ? 'text-success' : 'text-danger'}`}>
                                    {status}
                                </div>
                            )}
                        </form>

                    </div>

                    <div className="col-md-6 d-flex image-contact">
                        <div className="img" style={{ backgroundImage: 'url(/images/about.png)', backgroundColor: '#202020' }}></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
